import type { Settings } from '../context/settings-context';

/** Shared by the configurations and storefront-options pages, so it lives outside both. */
export const CART_SEARCH_TYPES = [
  'basic',
  'full',
  'off',
] as const satisfies Settings['cartSearchType'][];
